const getCookieDomain = (): string => {
  const hostName = window.location.hostname
  return hostName.split('.').slice(-2).join('.')
}

export default getCookieDomain
